"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Notification = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Notification.Spec';
const Role = User.GlobalUserRole.enums;
const withReadGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandSupportOperator, Role.BrandTechOperator, Role.Dealer, Role.DealerTechnician);
const withWriteGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager);
const ChannelListResponse = openapi_1.Response.Success(Notification.ChannelList).annotations({
    description: 'Notification channels',
});
const ChannelCreateResponse = openapi_1.Response.Success(Notification.ChannelCreateResult).annotations({
    description: 'Created notification channel; data is empty today',
});
const ChannelUpdateResponse = openapi_1.Response.Success(Notification.ChannelUpsertResult).annotations({
    description: 'Updated notification channel',
});
const NotificationListResponse = openapi_1.Response.Success(Notification.NotificationList).annotations({
    description: 'Notification rules',
});
const HistoryPageResponse = openapi_1.Response.Success(Notification.HistoryPage).annotations({
    description: 'Paginated notification delivery history',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful notification mutation',
});
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const UserQuery = effect_1.Schema.Struct({
    userId: effect_1.Schema.NonEmptyString,
});
const PositiveIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive());
const HistoryQuery = effect_1.Schema.Struct({
    ruleId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    userId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    deviceId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    channelId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    channelType: effect_1.Schema.optionalWith(Notification.ChannelType, { exact: true }),
    page: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }),
    pageSize: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }),
});
const listChannels = platform_1.HttpApiEndpoint.get('listChannels') `/channels`
    .setUrlParams(UserQuery)
    .addSuccess(ChannelListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Notification Channels')
    .annotate(platform_1.OpenApi.Description, 'Lists all notification channels for a user.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const deleteChannel = platform_1.HttpApiEndpoint.del('deleteChannel') `/channels`
    .setPayload(Notification.ChannelDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Deletes a notification channel by channelId. The admin runtime does not require userId or appId.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const createMobileChannel = platform_1.HttpApiEndpoint.post('createMobileChannel') `/channel/mobile`
    .setPayload(Notification.MobileChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Mobile Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Creates an active mobile push channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /channels.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateMobileChannel = platform_1.HttpApiEndpoint.put('updateMobileChannel') `/channel/mobile`
    .setPayload(Notification.MobileChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Mobile Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Replaces a mobile push channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const createEmailChannel = platform_1.HttpApiEndpoint.post('createEmailChannel') `/channel/email`
    .setPayload(Notification.EmailChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Email Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Creates an active email channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /channels.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateEmailChannel = platform_1.HttpApiEndpoint.put('updateEmailChannel') `/channel/email`
    .setPayload(Notification.EmailChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Email Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Replaces an email channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const createSmsChannel = platform_1.HttpApiEndpoint.post('createSmsChannel') `/channel/sms`
    .setPayload(Notification.SmsChannelCreatePayload)
    .addSuccess(ChannelCreateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create SMS Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Creates an active SMS channel for a user and app. The answer does not carry the id of the new channel: data is empty, so read the id from GET /channels.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateSmsChannel = platform_1.HttpApiEndpoint.put('updateSmsChannel') `/channel/sms`
    .setPayload(Notification.SmsChannelUpdatePayload)
    .addSuccess(ChannelUpdateResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update SMS Notification Channel')
    .annotate(platform_1.OpenApi.Description, 'Replaces an SMS channel and keeps it active. Returns 401 when payload userId/appId do not match the channel owner.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const listNotifications = platform_1.HttpApiEndpoint.get('listNotifications') ``
    .setUrlParams(UserQuery)
    .addSuccess(NotificationListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Notifications')
    .annotate(platform_1.OpenApi.Description, 'Lists notification rules for a user. Stored id is returned as both ruleId and notificationId.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const createNotification = platform_1.HttpApiEndpoint.post('createNotification') ``
    .setPayload(Notification.NotificationCreatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Notification')
    .annotate(platform_1.OpenApi.Description, 'Creates a notification rule. Admin mode accepts every scope and does not verify that channelIds or deviceSerialNumbers belong to userId. Message templates support {{SERIAL_NUMBER}}, {{DEVICE_ID}}, {{PROPERTY_VALUE}} and {{DATA.key}} substitutions.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateNotification = platform_1.HttpApiEndpoint.put('updateNotification') ``
    .setPayload(Notification.NotificationUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Update Notification')
    .annotate(platform_1.OpenApi.Description, 'Updates a notification rule. notificationId is required at runtime; ruleId is accepted as an alias and copied when notificationId is absent. The repository upserts, so an unknown id returns 200 and creates a new rule. rules is partitioned by userId: a different userId writes a copy in the other partition and leaves the original rule active. Admin mode does not verify the existing rule owner or that channelIds/deviceSerialNumbers belong to userId.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const deleteNotification = platform_1.HttpApiEndpoint.del('deleteNotification') ``
    .setPayload(Notification.NotificationDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Notification')
    .annotate(platform_1.OpenApi.Description, 'Deletes a notification rule. After ruleId→notificationId aliasing, only notificationId is validated — not the full create/update rule schema. Returns 401 when the rule belongs to another user.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const listHistory = platform_1.HttpApiEndpoint.get('listNotificationHistory') `/history`
    .setUrlParams(HistoryQuery)
    .addSuccess(HistoryPageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Notification History')
    .annotate(platform_1.OpenApi.Description, 'Returns sent notifications with filters and pagination. Known runtime quirk: when pageSize is supplied, the service passes page as the database page size.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.notification')
    .add(listChannels)
    .add(deleteChannel)
    .add(createMobileChannel)
    .add(updateMobileChannel)
    .add(createEmailChannel)
    .add(updateEmailChannel)
    .add(createSmsChannel)
    .add(updateSmsChannel)
    .add(listNotifications)
    .add(createNotification)
    .add(updateNotification)
    .add(deleteNotification)
    .add(listHistory)
    .prefix('/admin/notifications')
    .annotate(platform_1.OpenApi.Title, 'Notifications')
    .annotate(platform_1.OpenApi.Description, 'Admin notification rules, channels and delivery history')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map